<template>
  <el-dialog
    v-model="dialogVisible"
    :close-on-click-modal="clickModal"
    :show-close="false"
    destroy-on-close
    :width="width"
    :custom-class="['rounded-lg dialog-style', show_footer + 'footer']"
  >
    <template #title v-if="close_button">
      <div class="d_header">
        <el-icon :size="24" @click="handleClose" class="close_btn">
          <svg-icon icon-class="svg-dialog_close" />
        </el-icon>
        <span class="el-dialog__title">{{ title }}</span>
      </div>
    </template>
    <slot />
    <template #footer v-if="show_footer">
      <span class="dialog-footer">
        <el-button
          class="btn-style btn-submit button-style-green-hove"
          type="primary"
          @click="handleSubmit"
          :loading="isLoading"
          >{{ $t("router.public.confirm") }}</el-button
        >
        <el-button class="btn-style btn-cancel" @click="handleClose">{{
          $t("router.public.cancel")
        }}</el-button>
      </span>
    </template>
  </el-dialog>
</template>

<script setup lang="ts">
import { dialogProps } from "./props";
import { useCommon } from "/@/hooks";
import { computed, onBeforeUnmount } from "vue";

const { emitter } = useCommon();
const props = defineProps(dialogProps);
const emits = defineEmits(["update:show", "update:loading"]);

const dialogVisible = computed({
  get: () => props.show,
  set: (val) => {
    emits("update:show", val);
  },
});
const isLoading = computed({
  get: () => props.loading,
  set: (val) => {
    emits("update:loading", val);
  },
});
const handleClose = () => {
  dialogVisible.value = false;
};
const handleSubmit = () => {
  isLoading.value = true;
  emitter.emit("submit");
};
onBeforeUnmount(() => {
  emitter.off("submit");
});
</script>
<style lang="postcss">
.dialog-style {
  .el-dialog__header {
    text-align: center;
  }

  .el-dialog__title {
    margin-top: 20px;
    display: block;
    color: #262e44;
    font-size: 22px;
    font-weight: 500;
  }
  .close_btn {
    position: absolute;
    right: 15px;
    top: 15px;
  }
  .btn-style {
    height: 36px;
    min-width: 90px;
  }
  .btn-cancel {
    border: 1px solid #0cb060;
    background-color: #ffffff;
    color: #0cb060;
  }
  .el-dialog__footer {
    padding: 0 0 30px;
    text-align: center;
  }
}
.truefooter .el-dialog__body {
  padding-bottom: 0;
}
</style>
